mutation SetDialpadIntegrationIsEnabled($isEnabled: Boolean!) {
    setDialpadIntegrationIsEnabled(input: {isEnabled: $isEnabled}) {
        authUrl
    }
}
